{
  "checkedInTitle": "आप चेक-इन हो गए हैं",
  "postCheckInInstructions": "चेक-इन के बाद के निर्देश",
  "appointmentDetails": "अपॉइंटमेंट विवरण",
  "notifyWarehouse": "हमने वेयरहाउस को आपके आगमन की जानकारी दी ताकि वे अपनी उपलब्धता जांच सकें",
  "waitForStaff": "कृपया वेयरहाउस स्टाफ के आगे के निर्देशों की प्रतीक्षा करें",
  "unplannedDescription": "ऐसा लगता है कि आपके पास कोई अपॉइंटमेंट नहीं है। कृपया वेयरहाउस स्टाफ के आगे के निर्देशों की प्रतीक्षा करें।",
  "whatsappDelay": "पहला WhatsApp संदेश आने में एक मिनट तक का समय लग सकता है।",
  "bookNextTitle": "अगली बार के लिए अपॉइंटमेंट बुक करें",
  "bookNextBody": "Opendock पर रजिस्टर करें ताकि अगली बार जब आप इस सुविधा में आएं तो अपॉइंटमेंट बुक कर सकें",
  "helpFooter": "यदि आपको किसी सहायता या अतिरिक्त जानकारी की आवश्यकता है, तो कृपया वेयरहाउस स्टाफ से संपर्क करें",
  "finalize": "अंतिम रूप दें ({seconds})"
}
